export default __webpack_public_path__ + "static/media/sell-mobile.e01539a6.png";